/* eslint-disable react-hooks/rules-of-hooks */
import "./styles/headerNavigationStyle.less";
import React, { useEffect, useState, useCallback } from "react";
import Customer from "./current_customer";
import { CommandBarButton, IButtonProps } from "@fluentui/react";
import Toolbar from "./menu_toolbar";
import { CommandBarStyles, getCommandBarButtonStyles } from "./styles/toolbarStyles";
import { ButtonStyle } from "@/styles/buttonStyles";
import { _items } from "./toolbar";
import MenuButton from "./menuButton";
import { getCurrentInfo, getParameter, setLocalStorage } from "@/utilities/common";
import api from "@/api";
import { useNavigate } from "react-router-dom";
import { observer } from "@/utilities/storeHook";
import eventBus from "@/utilities/eventBus";
import getTemplate from "@/assets/templates";
import { GlobeClock24Regular } from "@fluentui/react-icons";

export const CustomButton: React.FunctionComponent<IButtonProps> = props => {
  const navigator = useNavigate();
  const { search } = location;
  const buttonOnMouseClick = () => navigator("/help" + search);
  return <CommandBarButton {...props} role="link" aria-label={props.ariaLabel} onClick={buttonOnMouseClick} styles={getCommandBarButtonStyles(props.styles)} />;
};

const Nav = () => {
  const routerParamsCID = getParameter("cid");
  const routerParamsAID = getParameter("aid");
  const [accounts, setAccounts] = useState<any>();
  const isCN = getCurrentInfo("region")?.toLowerCase() === "zh-cn";
  const getCustomerList = useCallback(() => {
    if (routerParamsCID) {
      setAccounts({});
      api.Customer.customerSelect({ cid: Number(routerParamsCID) })
        .then((response: any) => {
          getTemplate();
          if (response !== undefined) {
            return api.Customer.getCurrentCustomer({ cid: routerParamsCID });
          }
        })
        .then((res: any) => {
          if (res) {
            setLocalStorage("accounts", JSON.stringify(res));
            setAccounts({ ...res });
          }
        })
        .catch((error) => {
          console.error("获取客户列表失败:", error);
        });
    }
  }, [routerParamsCID]);

  useEffect(() => {
    getCustomerList();

    // 定义具名的事件处理函数
    const handleGetAccessToken = ({ token }: { token: any }) => {
      getCustomerList();
    };

    const handleShowAddAccount = (val: any) => {
      getCustomerList();
    };

    const handleCustomerInfoSave = (val: any) => {
      getCustomerList();
    };

    const handleAccountStatus = ({ accountStatus }: { accountStatus: number }) => {
      if (accountStatus === 2) {
        getCustomerList();
      }
    };

    // 移除可能存在的旧监听器
    eventBus.off("getAccessToken", handleGetAccessToken);
    eventBus.off("isShowAddAccount", handleShowAddAccount);
    eventBus.off("customerInfoSave", handleCustomerInfoSave);
    eventBus.off("accountStatus", handleAccountStatus);

    // 添加新的监听器
    eventBus.on("getAccessToken", handleGetAccessToken);
    eventBus.on("isShowAddAccount", handleShowAddAccount);
    eventBus.on("customerInfoSave", handleCustomerInfoSave);
    eventBus.on("accountStatus", handleAccountStatus);
    // 清理函数
    return () => {
      eventBus.off("getAccessToken", handleGetAccessToken);
      eventBus.off("isShowAddAccount", handleShowAddAccount);
      eventBus.off("customerInfoSave", handleCustomerInfoSave);
      eventBus.off("accountStatus", handleAccountStatus);
    };
  }, [routerParamsCID, routerParamsAID, getCustomerList]);

  return (
    <nav className="Component-navigationRegionContainer Component-container" aria-label="menu">
      <div className="Component-item"></div>
      {routerParamsCID && <div className="divider">
        <svg xmlns="http://www.w3.org/2000/svg" width="1" height="26" viewBox="0 0 1 26" fill="none" className="divider">
          <path d="M0.5 1L0.5 25" stroke="#393939" strokeLinecap="round" />
        </svg>
      </div>}
      <div>
      </div>
      <div className="Component-item">
        {routerParamsCID
          ? <MenuButton className={ButtonStyle.CompoundButton} menuList={accounts} />
          : null}
      </div>
      <div className="Component-item stretch"></div>
      <div className="Component-item">
        <div style={{ color: "#fff", display: "flex", alignItems: "center", gap: "6px" }}>
          {routerParamsCID && !isCN && <>
            <GlobeClock24Regular />
            <span>Time Zone:</span>
            <span>UTC+9 (Tokyo)</span>
          </>}
        </div>
        {routerParamsCID && <div className='header-breadcrumb'>
          <Toolbar
            items={_items}
            buttonAs={CustomButton}
            styles={CommandBarStyles}
            primaryGroupAriaLabel="Email actions"
            farItemsGroupAriaLabel="More actions"
          />
        </div>}
      </div>
      {routerParamsCID && <div className="divider">
        <svg xmlns="http://www.w3.org/2000/svg" width="1" height="26" viewBox="0 0 1 26" fill="none" className="divider">
          <path d="M0.5 1L0.5 25" stroke="#393939" strokeLinecap="round" />
        </svg>
      </div>}
      <div className="Component-item">
        <Customer menuList={accounts} />
      </div>
    </nav>
  );
};

export default observer(Nav);
